module.exports = __webpack_public_path__ + "img/empty_agreement.3f6a559e.svg";